<template>
	<div id="app">
		<template v-if="isOverviewPage">
			<PublicOverview />
		</template>
		<template v-else-if="isLoginPage">
			<LoginPage />
		</template>
		<template v-else>
			<div v-if="isLogin==false">
				<div class="container">
					<div class="row" style="height:100vh;">
						<div class="col-md-12 mx-auto">
							<div class="h-100 d-flex align-items-center justify-content-center">
								<Loader :loading="true" :color="'#007ACC'" class="mr-3" style="position: absolute"/>
								<div class="row mt-7">
									<div v-if="!this.$route.query.username">
										<div class="book">
											Please wait...
											<div class="book__page"></div>
											<div class="book__page"></div>
											<div class="book__page"></div>
										</div>
									</div>
									<div v-else>
										Please wait while token validate,
										<strong>{{this.$route.query.username}}</strong>.
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<AppInit v-if="isLogin==true" />
			<ASide v-if="isLogin==true" />
			<main v-if="isLogin==true" class="main-content main-content-background border-radius-lg"> <!-- mt-1-->
				<NavBar/>
				<keep-alive>
					<router-view/>
				</keep-alive>
			</main>
		</template>
	</div>
</template>

<script>
import 'vuejs-datatable/dist/themes/bootstrap-3.esm'
import AppInit from '@/AppInit.vue'
import ASide from '@/views/ASide.vue'
import NavBar from '@/views/NavBar.vue'
import Footer from '@/views/Footer.vue'
import {Config,AxiosWithJar} from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'

import PublicOverview from '@/views/pages/PublicOverview/Index.vue'
import LoginPage from '@/views/pages/Login.vue'

export default {
	name: 'App',
	components:{
		AppInit,
		ASide,
		NavBar,
		Loader,
		PublicOverview,
		LoginPage,
		//Footer,
	},
	data() {
		let isLogin=false
		let urlWEBSSO=Config().webSSO
		return {
			urlWEBSSO, isLogin, currentUrl: this.$route.path, isOverviewPage: false,
			isLoginPage: false,
		}
	},
	mounted() {
		document.title = "Dashboard Pertamina Retail"
		//alert("tes commit");

		if (this.$route.path === '/overview') {
			this.isOverviewPage = true;
		} else if (this.$route.path === '/login') {
            this.clearSession();
			this.isLoginPage = true;
		} else {
			// ARAHKAN KE HALAMAN SSO BILA TIDAK MEMILIKI SESSION LOGIN
			this.checkAuth();
		}

	},
	computed:{
		/*
		isOverviewPage() {
			// Mengecek apakah path saat ini adalah '/overview'
			return this.$route.path === '/overview';
			//return this.currentUrl === '/overview';
		} */
	},
	methods:{
		checkAuth() {
			if(this.isLogin == false) {
				// Cek LOCAL STORAGE
				let username = false, token = false

				// Validasi token from Local Storage
				if(localStorage.getItem('username') && localStorage.getItem('token')) {
					username=localStorage.getItem('username')
					token=localStorage.getItem('token')
					this.$store.commit('updateUsername',username)
					//console.log('check localstorage: ' + username + '-'  +token);
				}

				// Validasi token from url param
				if(this.$route.query.username && this.$route.query.token) {
					username=  this.$route.query.username
					token=  this.$route.query.token
					localStorage.setItem("username",username)
					localStorage.setItem("token",token)

					this.$store.commit('updateUsername',username)
					//console.log('check url params: ' + username + '-'  +token);
				}

				if(username && token) {
					//console.log('verify: ' + username + '-'  +token);
					this.verifySSO(username,token);
				} else {
					this.loginSSO()
				}
			}
		},
		async verifySSO(username,token) {
			// alert(username+""+token);
			let options = {
				mode:'cors',
				headers: {
					// 'Content-Type': 'application/json',
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				withCredentials: true
			}

			var data = ""
			// data={username:username,token:token}
			data = "username="+username+"&token="+token

			await AxiosWithJar().post(Config().apiURL+"/log/verify2",data,options).then((result)=> {
				if(result.data && result.data.loggedin === 1) {
					this.isLogin=true
					this.$store.commit('updateLoginInfo',result.data)
					//console.log(this.$store.getters.getLoginInfo)
				} else {
					this.loginSSO()
				}
				return result.data ? result.data.loggedin : 0
			}).catch(error=>{console.log('error: '+error)})
		},

		loginSSO() {
            this.clearSession();
			//console.log('login');
			//window.location.href = Config().webSSO
			//this.$router.push('/login');
			window.location.href = '/login';
		},
        clearSession() {
            localStorage.removeItem('username');
            localStorage.removeItem('token');
        }
	},
}
</script>

<style>
@import url('//fonts.googleapis.com/css?family=Open+Sans');
@import url( 'https://fonts.googleapis.com/css?family=Nunito');
/*
#146db7
rgba(20,109,185,1)

*/

/*body { font-family:'Open Sans', Sans-Serif; } */
body { font-family: 'Nunito' !important; }
h1, .h1, .h1, h2, .h2, .h2, h3, .h3, .h3, h4, .h4, .h4 {
    letter-spacing: 0.06rem !important;
}

h1, .h1, .h1, h2, .h2, .h2, h3, .h3, .h3, h4, .h4, .h4, h5, .h5, .h5, h6, .h6, .h6 {
    color: #252f40;
    font-family: 'Nunito' !important;
}

.home.container-fluid,.fuel.container-fluid{ min-height:105vh; display:tabel;}

.numbers h5 { font-size: 1rem !important; }
.stationCategories{ position: relative;}
.showDetail{ position:absolute; left:0; top:0; bottom: 0; right: 0;  height:auto; min-height:70vw; z-index:99999; transition: box-shadow 0.25s ease-in, background-color 0.25s ease-in;box-shadow: 0 2px 12px 0 rgb(0 0 0 / 16%); border-radius:1rem; background: #fff; }
.kl{ font-style:italic; font-size:11px; color:#ccc; }

.card.cardptpr{ border-radius:3px !important;}

.card.cardptpr .card-header{
  border-radius:3px 3px 0px 0px !important;
  /*background: linear-gradient(150deg, #146db7 , transparent); */
  background: #409EFF /*#0d6efd*/;
  color: #f1f1f1;
  padding: 2px 15px !important;
}
.card.cardptpr .card-header h6{ border-radius:5px !important; margin-top: 10px; color: #fff !important; font-size: 14px; font-weight: normal;}

.card.cardptpr .card-body { border-radius:3px !important; }

.el-card__header {
  padding-left:0px !important;
}

.animate-green { animation:10s animategreen ease infinite; border-radius: 0px !Important;}
.animate-red { animation:10s animatered ease infinite; border-radius: 0px !Important;}
.animate-yellow { animation:10s animateyellow ease infinite; border-radius: 0px !Important;}
.title-section{ padding: 10px 20px; margin-bottom:25px; border-radius: 5px 5px 0px 0px; color:#146db7; border-bottom:1px dashed rgba(20,109,185,.25);}

.main-content-background {
  /*background: #f8f9fa !important;*/
  background: #FAFBFC !important;
}

.btn {
  margin-bottom: 0px !important;
  box-shadow: 0 0px 0px -1px rgba(0, 0, 0, 0.0), 0 0px 0px -1px rgba(0, 0, 0, 0.00) !important;
  border-radius: 4px !important;
}

/* TABLE */


@keyframes animategreen {
  0% {
    background-color: transparent;
  }
  50% {
    background-color: transparent;
  }
  70% {
    background-color: rgba(76,164,55,.25);
  }
  75% {
    background-color: rgba(76,164,55,.35);
  }
  80% {
    background-color: rgba(76,164,55,.50);
  }
  85% {
    background-color: rgba(76,164,55,.35);
  }
  90% {
    background-color: rgba(76,164,55,.25);
  }
  95% {
    background-color: rgba(76,164,55,.15);
  }
  100% {
    background-color: transparent;
  }
}


@keyframes animateyellow {
  0% {
    background-color: transparent;
  }
  70% {
    background-color: rgba(172,196,55,.25);
  }
  75% {
    background-color: rgba(172,196,55,.35);
  }
  80% {
    background-color: rgba(172,196,55,.50);
  }
  85% {
    background-color: rgba(172,196,55,.35);
  }
  90% {
    background-color: rgba(172,196,55,.25);
  }
  95% {
    background-color: rgba(172,196,55,.15);
  }
  100% {
    background-color: transparent;
  }
}

@keyframes animatered {
  0% {
    background-color: transparent;
  }
  25% {
    background-color: transparent;
  }
  78% {
    background-color: rgba(199,37,28,.25);
  }
  80% {
    background-color: rgba(199,37,28,.50);
  }
  82% {
    background-color: rgba(199,37,28,.35);
  }
  84% {
    background-color: rgba(199,37,28,.25);
  }
  86% {
    background-color: rgba(199,37,28,.15);
  }
  100% {
    background-color: transparent;
  }
}

/*
LOADING
*/
.app-loader {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    /*background: #222;
    z-index:10000000;*/
    background: rgba(255, 255, 255, 0.9);

    display: flex;
    justify-content: center;
    align-items: center;
}


.spinner {
    -webkit-animation: rotator 1.4s linear infinite;
            animation: rotator 1.4s linear infinite;
  }

  @-webkit-keyframes rotator {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(270deg);
    }
  }

  @keyframes rotator {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(270deg);
    }
  }
  .path {
    stroke-dasharray: 187;
    stroke-dashoffset: 0;
    transform-origin: center;
    -webkit-animation: dash 1.4s ease-in-out infinite, colors 5.6s ease-in-out infinite;
            animation: dash 1.4s ease-in-out infinite, colors 5.6s ease-in-out infinite;
  }

  @-webkit-keyframes colors {
    0% {
      stroke: #4285F4;
    }
    25% {
      stroke: #DE3E35;
    }
    50% {
      stroke: #F7C223;
    }
    75% {
      stroke: #1B9A59;
    }
    100% {
      stroke: #4285F4;
    }
  }

  @keyframes colors {
    0% {
      stroke: #4285F4;
    }
    25% {
      stroke: #DE3E35;
    }
    50% {
      stroke: #F7C223;
    }
    75% {
      stroke: #1B9A59;
    }
    100% {
      stroke: #4285F4;
    }
  }
  @-webkit-keyframes dash {
    0% {
      stroke-dashoffset: 187;
    }
    50% {
      stroke-dashoffset: 46.75;
      transform: rotate(135deg);
    }
    100% {
      stroke-dashoffset: 187;
      transform: rotate(450deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dashoffset: 187;
    }
    50% {
      stroke-dashoffset: 46.75;
      transform: rotate(135deg);
    }
    100% {
      stroke-dashoffset: 187;
      transform: rotate(450deg);
    }
  }

  /*SPINNER 2*/
  .custom-loader {
  width: 40px;
  height: 40px;
  display: grid;
  border:3px solid #0000;
  border-radius: 50%;
  border-color:#E4E4ED #0000;
  animation: s6 1s infinite linear;
}
.custom-loader::before,
.custom-loader::after {
  content:"";
  grid-area: 1/1;
  margin:2px;
  border:inherit;
  border-radius: 50%;
}
.custom-loader::before {
  border-color:#95B5F4 #0000;
  animation:inherit;
  animation-duration: .5s;
  animation-direction: reverse;
}
.custom-loader::after {
  margin:8px;
}

@keyframes s6 {
  100%{transform: rotate(1turn)}
}

/** SPINNER 3 */
.custom-loader3 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side,#A5A6B8 94%,#0000) top/5px 5px no-repeat,
    conic-gradient(#0000 30%,#A5A6B8);
  -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 5px),#000 0);
  animation:s3 1s infinite linear;
}

@keyframes s3{
  100%{transform: rotate(1turn)}
}

  /** END LOADING */
</style>
